import Vue from 'vue';
import VueRouter from 'vue-router'
import store from '@/store'
import index from '@/pages/home';

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
	routes: [
		{	
			/*Index page*/
			path: '/:lang(' + store.getters.langs.join('|') + ')?',
			props: true,
			component: index,
			children: [
				{
					path: '',
					name: 'home',
					component: index
				},
				{
					path: '*',
					redirect: '/'
				}
			]
		},
		{
			path: '*',
			redirect: '/'
		}
	],
})

// on router.push 
// case 1: user hit / - set langApp language
// case 2: user hit /en - set desired language
// case 3: user was at /, and hit /en - set desired language
// case 3: user was at /en, and hit / - set default language

router.beforeEach((to, from, next) => {
	var langPage	= to.params.lang
	var langCurrent	= store.getters.lang
	var langBrowser	= store.getters.langBrowser;
	var langDefault	= store.getters.langDefault;

	console.log(
		'langCurrent:', langCurrent, 
		'langPage:', langPage, 
		'langBrowser:', langBrowser, 
		'langDefault:', langDefault,
		'routerQuery', router.currentRoute.query,
		'toQuery', to.query,
		'fromQuery', from.query,
	)

	// при первом запуске и пустом langPage (переход на /) и langBrowser != дефолтный
	// - включить переадресацию на langBrowser
	if(!langCurrent && !langPage && langBrowser != langDefault) {
		console.log('redirect to langBrowser /' + langBrowser, to.query, langBrowser, langDefault)
		router.push({path: '/' + langBrowser, query: to.query})
		return
	}

	// при повторном запуске и пустом langPage (переход на /) и сохраненный langCurrent != дефолтный
	// - включить переадресацию на langCurrent
	if(langCurrent && !langPage && langCurrent != langDefault) {
		console.log('redirect to langCurrent /' + langCurrent, to.query, langPage, langDefault)
		router.push({path: '/' + langCurrent, query: to.query})
		return
	}

	// при переходе на /дефолтный
	// - включить переадресацию на /
	if(langPage && langPage == langDefault) {
		console.log('redirect to langDefault /', to.query, langPage, langDefault)
		store.commit('changeLang', langPage)
		router.push({path: '/', query: to.query})
		return
	}

	// для маршрута "/" установить язык по умолчанию
	if (!langPage) langPage = langDefault;

	// установить langCurrent = langPage (активировать перевод)
	console.log('setLang', langPage)
	store.commit('changeLang', langPage)

	next()
})

export default router